module.exports = __webpack_public_path__ + "img/finish-reservation.3c9b5880.svg";